/**
 * Хук списка отелей (tenants).
 *
 * REAL: GET /v1/admin/tenants — реальный endpoint admin_subscription
 * (listAdminTenants из @hsc/api-client). RBAC: platform_admin only.
 */
import { useQuery } from '@tanstack/react-query';
import { listAdminTenants } from '@hsc/api-client';
import type { AdminTenantsListResponse } from '@hsc/types';

export function useHotels(status?: string) {
  return useQuery<AdminTenantsListResponse>({
    queryKey: ['admin', 'tenants', status ?? 'all'],
    queryFn: () => listAdminTenants(status !== undefined ? { status } : {}),
  });
}
